// UseRef y useEffect se usa aqui para brindar accesibilidad a usuarios de teclado y screenreaders
import {useRef, useEffect} from "react";

// Funcion para devolver el ultimo valor de una variable, empieza como undefined hasta que finalice el render y entre en ejecucion el useEffect, useEffect se explica al final
export function usePrevious(valor){
    const ref = useRef();
    useEffect(() => {
        ref.current = valor;
    });
    return ref.current;
}